export const PAGE_TITLE = 'Contact Types';

export const contentOptions = {
  isScrollable: false,
};

export const helmetProps = {
  title: PAGE_TITLE,
};

export const errorHandlingLayoutClasses = {
  wrapper: 'flex-1 overflow-hidden',
  contentWrapper: 'flex flex-col flex-1 overflow-hidden',
};

export const TableCellId = {
  NAME: 'name',
  KIND: 'kind',
  DRIVE_PERSON: 'drivePerson',
  DRIVE_COMPANY: 'driveCompany',
  MAPPING_SOURCE: 'mappingSource',
  STATUS: 'status',
  ACTION: 'action',
};

export const ContactTypesTab = {
  TYPES: 'types',
  DRIVE_MAPPING: 'drive-mapping',
};

export const CONTACT_TYPES_TABS = [
  { value: ContactTypesTab.TYPES, label: 'Contact types' },
  { value: ContactTypesTab.DRIVE_MAPPING, label: 'DataVerify party mapping' },
];

export const NEW_CONTACT_TYPE_BUTTON_LABEL = 'New contact type';

export const closedDrawerState = {
  isOpen: false,
  contactTypeId: null,
  presetFamily: null,
};

export const NOT_APPLICABLE_TEXT = '—';

export const RESET_MAPPING_LABEL = 'Reset to default';
